import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rossi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
